import {Action} from 'redux';
import {GET_EXTRA_EVENTS} from "../../../constants/ExtraConstants";

export const GetAlertsAction = (): Action => ({type: GET_EXTRA_EVENTS});
